import { render, staticRenderFns } from "./ProfilePost.vue?vue&type=template&id=e74908a2"
import script from "./ProfilePost.vue?vue&type=script&lang=js"
export * from "./ProfilePost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports